
import type { IconProps } from 'src/types/icons';

const LogoutIcon = (props: IconProps) => (
  <svg {...props} width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.75 5.75L20.75 9.75M20.75 9.75L16.75 13.75M20.75 9.75H7.75M13.75 1.95404C12.4752 1.18827 10.9952 0.75 9.41667 0.75C4.6302 0.75 0.75 4.77944 0.75 9.75C0.75 14.7206 4.6302 18.75 9.41667 18.75C10.9952 18.75 12.4752 18.3117 13.75 17.546" stroke="#EA1C1C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
export default LogoutIcon;
